/*
 * Public API Surface of sdk-textbox
 */

export { SDKTextboxModule } from './lib/sdk-textbox.module';
export { SDKTextboxComponent } from './lib/sdk-textbox.component';
